module.exports = "div.service {\n  margin-bottom: 1em;\n  padding-bottom: 1em;\n  border-bottom: solid 1px #ddd; }\n  @media (min-width: 767px) {\n    div.service h3 {\n      margin-top: 0px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/services.component.scss
// module id = 242
// module chunks = 1